import {
  ORDER_DETAIL,
  ORDER_DETAIL_ERROR,
  ORDER_DETAIL_LOADING,
  ORDER_ERROR,
  ORDER_LIST,
  ORDER_LOADING,
  ORDER_RESPONSE_ERROR,
  ORDER_RESPONSE_LOADING,
  ORDER_STATUS_UPDATE_ERROR,
  ORDER_STATUS_UPDATE_LOADING,
} from "../actions/type";

const initialState = {
  items: [],
  counts: {},
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 1,
  },
  loading: false,
  error: "",
  detail: null,
  detailLoading: false,
  detailError: "",
  statusUpdateLoading: false,
  statusUpdateError: "",
  responseLoading: false,
  responseError: "",
};

export default function order(state = initialState, action) {
  switch (action.type) {
    case ORDER_LIST:
      return { ...state, ...action.payload };
    case ORDER_LOADING:
      return { ...state, loading: action.payload };
    case ORDER_ERROR:
      return { ...state, error: action.payload };
    case ORDER_DETAIL:
      return { ...state, detail: action.payload };
    case ORDER_DETAIL_LOADING:
      return { ...state, detailLoading: action.payload };
    case ORDER_DETAIL_ERROR:
      return { ...state, detailError: action.payload };
    case ORDER_STATUS_UPDATE_LOADING:
      return { ...state, statusUpdateLoading: action.payload };
    case ORDER_STATUS_UPDATE_ERROR:
      return { ...state, statusUpdateError: action.payload };
    case ORDER_RESPONSE_LOADING:
      return { ...state, responseLoading: action.payload };
    case ORDER_RESPONSE_ERROR:
      return { ...state, responseError: action.payload };
    default:
      return state;
  }
}
